import {BASE_URL} from './BaseUrl';
import {AUTH_TOKEN, getToken} from '../utils/Token';
import axios from 'axios';

const token = getToken();

export const apiInstance = axios.create({
  // withCredentials: true,
  baseURL: BASE_URL,
  headers: {
    Authorization: token ? `Bearer ${token}` : AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const antiWebHookApi = {
  getAntiWebHook(id) {
    return apiInstance.get(`/api/anti-webhook/${id}`);
  },
  updateAntiWebHook(id, body) {
    return apiInstance.post(`/api/anti-webhook/${id}/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/webhook`);
  },
};

export const antiSpamApi = {
  getAntiSpam(id) {
    return apiInstance.get(`/api/anti-spam/${id}`);
  },
  updateAntiSpam(id, body) {
    return apiInstance.post(`/api/anti-spam/${id}/update`, body);
  },
  getAntiSpamAdvanced(id) {
    return apiInstance.get(`/api/anti-spam/${id}/advanced`);
  },
  updateAntiSpamAdvanced(id, body) {
    return apiInstance.post(`/api/anti-spam/${id}/advanced/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/spam`);
  },
};

export const antiNukeApi = {
  getAntiNuke(id) {
    return apiInstance.get(`/api/anti-nuke/${id}`);
  },
  updateAntiNuke(id, body) {
    return apiInstance.post(`/api/anti-nuke/${id}/update`, body);
  },
  getAntiNukeAdvanced(id) {
    return apiInstance.get(`/api/anti-nuke/${id}/advanced`);
  },
  updateAntiNukeAdvanced(id, body) {
    return apiInstance.post(`/api/anti-nuke/${id}/advanced/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/nuke`);
  },
};

export const antiRaidApi = {
  getAntiRaid(id) {
    return apiInstance.get(`/api/anti-raid/${id}`);
  },
  updateAntiRaid(id, body) {
    return apiInstance.post(`/api/anti-raid/${id}/update`, body);
  },
  getAntiRaidAdvanced(id) {
    return apiInstance.get(`/api/anti-raid/${id}/advanced`);
  },
  updateAntiRaidAdvanced(id, body) {
    return apiInstance.post(`/api/anti-raid/${id}/advanced/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/raid`);
  },
};

export const verificationApi = {
  getVerification(id) {
    return apiInstance.get(`/api/verification/${id}`);
  },
  updateVerification(id, body) {
    return apiInstance.post(`/api/verification/${id}/update`, body);
  },
  getVerificationAdvanced(id) {
    return apiInstance.get(`/api/verification/${id}/advanced`);
  },
  updateVerificationAdvanced(id, body) {
    return apiInstance.post(`/api/verification/${id}/advanced/update`, body);
  },
  getVerificationRules(id) {
    return apiInstance.get(`/api/verification/${id}/rules`);
  },
  updateVerificationRules(id, body) {
    return apiInstance.post(`/api/verification/${id}/rules/update`, body);
  },
  getVerificationMessage(id) {
    return apiInstance.get(`/api/verification/${id}/message`);
  },
  updateVerificationMessage(id, body) {
    return apiInstance.post(`/api/verification/${id}/message/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/verification`);
  },
};

export const detectionApi = {
  getDetection(id) {
    return apiInstance.get(`/api/detection/${id}`);
  },
  updateDetection(id, body) {
    return apiInstance.post(`/api/detection/${id}/update`, body);
  },
  getDetectionAdvanced(id) {
    return apiInstance.get(`/api/detection/${id}/advanced`);
  },
  updateDetectionAdvanced(id, body) {
    return apiInstance.post(`/api/detection/${id}/advanced/update`, body);
  },
  getLogs(id) {
    return apiInstance.get(`/api/logs/${id}/detection`);
  },
};

export const membersApi = {
  getMembers(id) {
    return apiInstance.get(`/discord/members/${id}`);
  },
};

export const channelsApi = {
  getChannels(id) {
    return apiInstance.get(`/discord/channels/${id}`);
  },
};

export const rolesApi = {
  getRoles(id) {
    return apiInstance.get(`/discord/roles/${id}`);
  },
};

export const overviewApi = {
  getOverview(id) {
    return apiInstance.get(`/api/overview/${id}`);
  },
  getOverviewInfo(id) {
    return apiInstance.get(`/api/overview/info/${id}`);
  },
  updateOverviewInfo(id, body) {
    return apiInstance.post(`/api/overview/info/${id}/update`, body);
  },
};

export const guildsApi = {
  getGuilds() {
    return apiInstance.get(`/discord/guilds`);
  },
};

export const statsApi = {
  getDetection() {
    return apiInstance.get(`/stats/detections`);
  },
  getMembers() {
    return apiInstance.get(`/stats/members`);
  },
  getGuilds() {
    return apiInstance.get(`/stats/guilds`);
  },
};

export const getAuthLink = (code) => {
  return apiInstance.get(`/discord/token?code=${code}`);
};

export const settingsApi = {
  getSettings(id) {
    return apiInstance.get(`/api/settings/${id}`);
  },
  updateSettings(id, body) {
    return apiInstance.post(`/api/settings/${id}/update`, body);
  },
};

export const currentUserApi = {
  getMe() {
    return apiInstance.get(`/discord/me`);
  },
};

export const logsApi = {
  getAllLogs(id) {
    return apiInstance.get(`/api/logs/${id}`);
  },
};
